import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import RendersIcons from './RendersIcons'
import { Dialog, DialogContent, Divider, List, Box, Typography, Button } from "@mui/material";
import OrderInputText from './OrderInputText';
import { getOrder } from "../api/Api";

export default function SearchOrder(props) {
  const [searchOrderCode, setSearchOrderCode] = React.useState("");
  const [searchOrder, setsearchOrder] = React.useState([]);
  const [isErrorGetOrder, setErrorGetOrder] = React.useState(false);
  const [userName, setUserName] = React.useState("");



  const OrderPopup = () => (
    <Dialog
      open={props.isOpenSearchOrder}
      onClose={() => props.setOpenSearchOrder(false)}
      maxWidth="sm"
      fullWidth={false}
    >
      <DialogContent
        sx={{
          minWidth: 300,
          maxWidth: 500,
          borderRadius: 2,
          p: 2,
          backgroundColor: '#fff2d7'
        }}
      >
        <Divider sx={{ mb: 2 }} key={"search"}/>
        <List>
          {renderCart()}
        </List>
      </DialogContent>
    </Dialog>
  );


  const renderCart = () => {
    var renderItemPopUp = []

    renderItemPopUp.push(
      <OrderInputText key={"searcode"} text={searchOrderCode} setText={setSearchOrderCode} isError={isErrorGetOrder} label={userName} />
    )

    // Show the order summary
    searchOrder.forEach((value, index) => {
      var tot = value.quantity * value.price
      allPrice = allPrice + tot
      if (tot !== 0) {
        renderItemPopUp.push(
          <ListItem key={index} sx={{
            '& .MuiListItemIcon-root': { color: '#000' }
          }}>
            <ListItemIcon>
              <RendersIcons title={"PIZZA"} />
            </ListItemIcon>
            <ListItemText
              primary={value.name}
              secondary={"X" + value.quantity + "  •  €" + value.price}
              style={{ minWidth: "200px", flexGrow: 1 }}

            />
            <ListItemIcon>
              <RendersIcons title={value.status} />
            </ListItemIcon>
          </ListItem>
        )
      }
    });

    renderItemPopUp.push(
      <div key="space" style={{ height: 60, width: '100%' }}>
      </div>
    )

    renderItemPopUp.push(
      <Button
        key={"getOrder"}
        variant="contained"
        disabled={searchOrderCode === ""}
        onClick={() => { getOrderByCode(searchOrderCode) }}
        sx={{
          width: "100%",
          backgroundColor: "#22c55e",
          color: "#000",
          fontWeight: "bold",
          textTransform: "none",
          borderRadius: 2,
          py: 1.5,
          "&:hover": {
            backgroundColor: "#16a34a",
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%"
          }}
        >
          <Typography variant="body1">
            {"Get Order"}
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {"€" + allPrice}
          </Typography>
        </Box>
      </Button>
    )
    return renderItemPopUp;
  }

  const getOrderByCode = (value) => {
    getOrder(value)
      .then(result => {
        setsearchOrder(result.pizzas);
        setUserName(result.customerName)
        setErrorGetOrder(false)
      })
      .catch(err => setErrorGetOrder(true));
  }

  let allPrice = 0
  return (
    <React.Fragment>
      {OrderPopup()}
    </React.Fragment>
  );
}